import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import CheckBox from "../../../components/check-box";

import {
    clear_maintenance_supplier,
    CREATE_MAINTENANCE_SUPPLIER,
    updateMaintenanceSupplier,
    UPDATE_MAINTENANCE_SUPPLIER,
    getAllMaintenanceSupplier,
    createMaintenanceSupplier
} from "../../../redux/maintenance_supplier";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const MaintenanceSupplier = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_maintenance_supplier = useSelector((state) => state.maintenance_supplier_module._get_all_maintenance_supplier);
    const _create_maintenance_supplier = useSelector((state) => state.maintenance_supplier_module._create_maintenance_supplier);
    const _update_maintenance_supplier = useSelector((state) => state.maintenance_supplier_module._update_maintenance_supplier);
    const [data, setData] = useState([]);

    useEffect(() => {
        dispatch(getAllMaintenanceSupplier(token, '', 1));
    }, [token, dispatch]);

    useEffect(() => {
        if (_get_all_maintenance_supplier && _get_all_maintenance_supplier.data && _get_all_maintenance_supplier.data.datos) {
            setData(_get_all_maintenance_supplier.data.datos);
        }
    }, [_get_all_maintenance_supplier]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        nombre: "",
        tipo_servicio: "",
        correo: "",
        telefono: "",
        direccion: "",
        activo: "",
        id: 0
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_maintenancesupplier').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        setForm({...form,
                            nombre: item.nombre,
                            tipo_servicio: item.tipo_servicio,
                            correo: item.correo,
                            telefono: item.telefono,
                            direccion: item.direccion,
                            activo: item.activo
                        });
                    },
                })
            }
        }
        setActions(act);
    // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        if (e.target.name === 'activo') {
            setForm({
                ...form,
                [e.target.name]: e.target.checked,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    useEffect(() => {
        if (_create_maintenance_supplier.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_maintenance_supplier(CREATE_MAINTENANCE_SUPPLIER));
            dispatch(getAllMaintenanceSupplier(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_maintenance_supplier.status !== 0) {
            dispatch(clear_maintenance_supplier(CREATE_MAINTENANCE_SUPPLIER));
            toast.error(_create_maintenance_supplier.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_maintenance_supplier, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_maintenance_supplier.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_maintenance_supplier(UPDATE_MAINTENANCE_SUPPLIER));
            dispatch(getAllMaintenanceSupplier(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_maintenance_supplier.status !== 0) {
            dispatch(clear_maintenance_supplier(UPDATE_MAINTENANCE_SUPPLIER));
            toast.error(_update_maintenance_supplier.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_maintenance_supplier, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.tipo_servicio === "") {
            toast.error("Debe ingresar el tipo de servicio", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id === 0) {
            dispatch(createMaintenanceSupplier(token, form));
        } else {
            dispatch(updateMaintenanceSupplier(token, id, form));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Proveedores de mantenimientos", link: "/proveedores-mantenimientos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_maintenancesupplier').length > 0 ?
                                    <Button type="button" text="Crear" theme="btn btn-success" onClick={() => {
                                        setModal(true); 
                                        setForm({...form, nombre: '', tipo_servicio: '', correo: '', telefono: '', direccion: ''});
                                        setId(0);
                                    }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "nombre",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                            {
                                                name: "tipo_servicio",
                                                label: "Tipo de servicio",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Proveedor de mantenimiento</h5>
                    </div>
                    <div className="modal-body p-2">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <Input
                                    name="nombre"
                                    label="Nombre"
                                    onChange={handleChange}
                                    value={form.nombre}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="tipo_servicio"
                                    label="Tipo de servicio"
                                    onChange={handleChange}
                                    value={form.tipo_servicio}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="correo"
                                    label="Correo"
                                    onChange={handleChange}
                                    value={form.correo}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="telefono"
                                    label="Teléfono"
                                    onChange={handleChange}
                                    value={form.telefono}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="direccion"
                                    label="Dirección"
                                    onChange={handleChange}
                                    value={form.direccion}
                                />
                            </div>
                            {(id !== 0) &&
                                <div className="form-group">
                                    <CheckBox label="Activo" name="activo" id="activo" onChange={handleChange}state={form.activo}/>
                                </div> 
                            }
                            <div className="text-center">
                                <button type="button" className="btn btn-outline-dark" onClick={() => {
                                    setModal(false);
                                }}> Cancelar
                                </button>
                                <Button type="submit" text="Guardar" theme="btn btn-success" classes="m-1" disabled={isLoading}/>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default MaintenanceSupplier;
